"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dateHelper = require("../../../helpers/dateHelper");
var _table = require("../../data/table");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _numberFormatter = require("../../../helpers/numberFormatter");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var baseClass = (0, _cssClassesHelper.getBEMClasses)('order-history-table');
var DepositsStatusComponent = function DepositsStatusComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('order'),
    t = _useTranslation.t;
  var data = props.data,
    decimalPlaces = props.decimalPlaces,
    config = props.config,
    getDepositTickets = props.getDepositTickets,
    selectedAccountId = props.selectedAccountId,
    fetching = props.fetching;
  var maxLines = config.maxLines,
    usePagination = config.usePagination;
  (0, _react.useEffect)(function () {
    getDepositTickets();
  }, [getDepositTickets, selectedAccountId]);
  var columns = (0, _react.useMemo)(function () {
    return [{
      header: t('Product'),
      dataTest: 'Product',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref) {
        var row = _ref.row;
        return row.original.AssetName;
      }
    }, {
      header: t('Amount'),
      dataTest: 'Amount',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref2) {
        var row = _ref2.row;
        return (0, _numberFormatter.formatNumberToLocale)(row.original.Amount, decimalPlaces[row.original.AssetId]);
      }
    }, {
      header: t('Status'),
      dataTest: 'Status',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref3) {
        var row = _ref3.row;
        return t(row.original.Status);
      }
    }, {
      header: t('Transaction Id'),
      dataTest: 'Transaction Id',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref4) {
        var row = _ref4.row;
        return row.original.TicketNumber;
      }
    }, {
      header: t('To Address'),
      dataTest: 'To Address',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref5) {
        var row = _ref5.row;
        var addr = '-';
        try {
          var _data = JSON.parse(row.original.DepositInfo);
          if (_data.ToAddress) {
            addr = _data.ToAddress;
          }
        } catch (e) {
          console.error('Error parsing To Address:', e);
        }
        return /*#__PURE__*/_react["default"].createElement("span", {
          className: "address"
        }, addr);
      }
    }, {
      header: t('Created'),
      dataTest: 'Created',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref6) {
        var row = _ref6.row;
        return (0, _dateHelper.formatDateTime)(row.original.CreatedTimestamp);
      }
    }, {
      header: t('Fee'),
      dataTest: 'Fee',
      meta: {
        textAlign: 'center'
      },
      cell: function cell(_ref7) {
        var row = _ref7.row;
        return row.original.FeeAmt;
      }
    }];
  }, [t, decimalPlaces]);
  return /*#__PURE__*/_react["default"].createElement(_table.Table, {
    className: baseClass(),
    columns: columns,
    data: data,
    stickyColumns: {
      right: ['Actions']
    },
    loading: fetching,
    emptyMessage: t('No data is available'),
    pagination: (0, _react.useMemo)(function () {
      return usePagination ? {
        pageSize: maxLines,
        variant: 'simple'
      } : undefined;
    }, [usePagination, maxLines]),
    scrollable: true
  });
};

/*
  t('Deposit Status');
 */
DepositsStatusComponent.title = 'Deposit Status';
DepositsStatusComponent.componentName = 'DepositsStatusComponent';
DepositsStatusComponent.propTypes = {
  data: _propTypes["default"].array.isRequired,
  decimalPlaces: _propTypes["default"].object.isRequired,
  config: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = DepositsStatusComponent;